export default function (pageName: string | null = null) {
  const config = useRuntimeConfig()
  let title = config.public.app_name;

  if (pageName) {
    title = title + ' - ' + pageName;
  }

  useHead({
    title
  })
}
